import { yearPickerClasses } from "@mui/x-date-pickers";
import * as yup from "yup";

export const addTreatmentTypeSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  totalPayment: yup
    .number()
    .positive()
    .required("Total payment value is required"),
});

export const treatmentTypeSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  totalPayment: yup
    .number()
    .positive()
    .required("Total payment value is required"),
});
